export function canUseMediaLists(userId) {
  const PROD_ALLOWLIST = [
    1, // TrevorMitchell
    13, // RileyMitchell
  ];
  if (process.env.NODE_ENV === "development") {
    return true;
  } else {
    return PROD_ALLOWLIST.includes(userId);
  }
}
